import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { designById, withColors } from "../lib/inviteDesigns";
import SeoLandingPage from "./SeoLandingPage";

export default function SocialInvitePage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ name: "", email: "", phone: "", note: "" });
  const [done, setDone] = useState(false);
  const [seo, setSeo] = useState(false);
  // /s/:x is shared by social-invite tokens and SEO landing pages (/s/weddings etc.): fall back to the SEO page when it's not an invite.
  useEffect(() => {
    api.get(`/public/social-invites/${token}`).then((r) => setD(r.data)).catch((e) => {
      api.get(`/seo/landing/${token}`).then(() => setSeo(true)).catch(() => setErr(formatApiError(e)));
    });
  }, [token]);
  if (seo) return <SeoLandingPage slug={token} />;
  if (err) return <div className="min-h-screen flex items-center justify-center p-6 text-center text-[var(--muted)]" data-testid="social-invite-error">{err}</div>;
  if (!d) return <div className="min-h-screen bg-black" />;
  const pal = withColors(designById(d.design_id), d.colors).pal;
  async function send(e) {
    e.preventDefault();
    try { await api.post(`/public/social-invites/${token}/request`, f); setDone(true); } catch (er) { toast.error(formatApiError(er)); }
  }
  const inp = "social-inp w-full rounded-xl px-4 py-3 border outline-none";
  const vars = { "--t": pal.text, "--a": pal.accent };
  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-6 py-12" style={{ background: `radial-gradient(circle at 50% 30%, ${pal.panel}, ${pal.bg})`, color: pal.text }} data-testid="social-invite">
      <div className="w-full max-w-sm text-center">
        <p className="text-[11px] uppercase tracking-[0.35em] mb-3 font-semibold" style={{ color: pal.accent }}>{d.headline}</p>
        <h1 className="text-5xl mb-3" style={{ fontFamily: `'${designById(d.design_id).font}', serif` }}>{d.couple_names}</h1>
        <p className="text-sm opacity-80 mb-8">This invitation is private. Ask to join and {d.couple_names} will send you your personal invite once they approve.</p>
        {done ? <p className="text-sm" data-testid="social-invite-sent">Thank you! Your request was sent to the couple.</p> : (
          <form onSubmit={send} className="space-y-3 text-left" style={vars}>
            <input required maxLength={80} placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inp} data-testid="social-req-name" />
            <input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inp} data-testid="social-req-email" />
            <input maxLength={30} placeholder="Phone (optional)" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className={inp} data-testid="social-req-phone" />
            <input maxLength={300} placeholder="How do you know the couple?" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className={inp} data-testid="social-req-note" />
            <button className="w-full py-3 rounded-full text-xs uppercase tracking-widest" style={{ background: pal.accent, color: pal.bg }} data-testid="social-req-send">Request my invite</button>
          </form>
        )}
      </div>
    </div>
  );
}
